import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box, Button, Card, Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, IconButton, Chip, Typography, Dialog,
  DialogTitle, DialogContent, DialogActions
} from '@mui/material';
import { Add, Edit, Delete, CheckCircle } from '@mui/icons-material';
import { getCentres, deleteCentre } from '../services/api';

function CentresPage() {
  const [centres, setCentres] = useState([]);
  const [deleteDialog, setDeleteDialog] = useState({ open: false, centre: null });
  const navigate = useNavigate();

  useEffect(() => { loadCentres(); }, []);

  const loadCentres = async () => {
    try {
      const { data } = await getCentres();
      setCentres(data);
    } catch (error) {
      console.error('Erreur:', error);
    }
  };

  const handleDelete = async () => {
    try {
      await deleteCentre(deleteDialog.centre._id);
      setDeleteDialog({ open: false, centre: null });
      loadCentres();
    } catch (error) {
      console.error('Erreur:', error);
    }
  };

  const typeColors = { reference: 'error', competence: 'warning', expert: 'info', hopital: 'success' };
  const typeLabels = { reference: 'Reference', competence: 'Competence', expert: 'Expert', hopital: 'Hopital' };

  return (
    <Box>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
        <Typography variant="h4" fontWeight="bold">Centres</Typography>
        <Button variant="contained" startIcon={<Add />} onClick={() => navigate('/centres/new')}>
          Nouveau centre
        </Button>
      </Box>

      <Card>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Nom</TableCell>
                <TableCell>Type</TableCell>
                <TableCell>Ville</TableCell>
                <TableCell>Specialites</TableCell>
                <TableCell>Verifie</TableCell>
                <TableCell align="right">Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {centres.map((centre) => (
                <TableRow key={centre._id} hover>
                  <TableCell><Typography fontWeight="medium">{centre.name}</Typography></TableCell>
                  <TableCell><Chip size="small" label={typeLabels[centre.type]} color={typeColors[centre.type]} /></TableCell>
                  <TableCell>{centre.address?.city}</TableCell>
                  <TableCell>
                    {centre.specialites?.slice(0, 3).map((s) => (
                      <Chip key={s} size="small" label={s} sx={{ mr: 0.5 }} />
                    ))}
                  </TableCell>
                  <TableCell>{centre.isVerified && <CheckCircle color="success" />}</TableCell>
                  <TableCell align="right">
                    <IconButton size="small" onClick={() => navigate(`/centres/${centre._id}`)}><Edit /></IconButton>
                    <IconButton size="small" color="error" onClick={() => setDeleteDialog({ open: true, centre })}><Delete /></IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Card>

      <Dialog open={deleteDialog.open} onClose={() => setDeleteDialog({ open: false, centre: null })}>
        <DialogTitle>Confirmer la suppression</DialogTitle>
        <DialogContent>Supprimer "{deleteDialog.centre?.name}" ?</DialogContent>
        <DialogActions>
          <Button onClick={() => setDeleteDialog({ open: false, centre: null })}>Annuler</Button>
          <Button color="error" variant="contained" onClick={handleDelete}>Supprimer</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}

export default CentresPage;
